import trainingApi from './trainingApi';
// Uses the training-specific axios instance (training_token in localStorage).

const trainingService = {

  // ---- Courses ----

  getCourses: async () => {
    const response = await trainingApi.get('/api/training/courses');
    return response.data;
  },

  getCourseFields: async (courseId) => {
    const response = await trainingApi.get(`/api/training/courses/${courseId}/fields`);
    return response.data;
  },

  // ---- Clients ----

  getClients: async () => {
    const response = await trainingApi.get('/api/training/clients');
    return response.data;
  },

  // ---- Submissions ----

  createSubmission: async (formData) => {
    const response = await trainingApi.post('/api/training/submissions', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  listSubmissions: async () => {
    const response = await trainingApi.get('/api/training/submissions');
    return response.data;
  },

  getSubmission: async (submissionId) => {
    const response = await trainingApi.get(`/api/training/submissions/${submissionId}`);
    return response.data;
  },

  updateSubmission: async (submissionId, formData) => {
    const response = await trainingApi.put(`/api/training/submissions/${submissionId}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  // ---- Workflow ----

  submitForReview: async (submissionId) => {
    const response = await trainingApi.post(
      `/api/training/submissions/${submissionId}/submit-for-review`
    );
    return response.data;
  },

  sendBack: async (submissionId, comments) => {
    const response = await trainingApi.post(
      `/api/training/submissions/${submissionId}/send-back`,
      { comments }
    );
    return response.data;
  },

  approve: async (submissionId, trainingClientId) => {
    const response = await trainingApi.post(
      `/api/training/submissions/${submissionId}/approve`,
      { training_client_id: trainingClientId }
    );
    return response.data;
  },

  // ---- PDF ----

  generatePdf: async (submissionId) => {
    const response = await trainingApi.post(
      `/api/training/submissions/${submissionId}/generate-pdf`
    );
    return response.data;
  },

  downloadPdf: async (submissionId) => {
    const response = await trainingApi.get(
      `/api/training/submissions/${submissionId}/download`,
      { responseType: 'blob' }
    );
    return response;
  },

  previewPdf: async (submissionId) => {
    const response = await trainingApi.get(
      `/api/training/submissions/${submissionId}/preview-pdf`,
      { responseType: 'blob' }
    );
    return response;
  },

  getTraineePhoto: async (submissionId) => {
    const response = await trainingApi.get(
      `/api/training/submissions/${submissionId}/photo`,
      { responseType: 'blob' }
    );
    return response;
  },

  // ---- Reports ----

  getTrainingMonthly: async (year) => {
    const response = await trainingApi.get('/api/reports/training/monthly', { params: { year } });
    return response.data;
  },

  getTrainingUtilization: async (year) => {
    const response = await trainingApi.get('/api/reports/training/utilization', { params: { year } });
    return response.data;
  },

  // ---- Public Verification ----

  verifyByToken: async (token) => {
    // Public endpoint — no auth needed; use plain axios or trainingApi (no token required)
    const response = await trainingApi.get(`/api/training/verify/${token}`);
    return response.data;
  },
};

export default trainingService;
